export default class DtoDistributionNetwork {
    constructor(obj) {
        this.id = obj.id // Option[Long],
        this.idInstallation = obj.idInstallation // Option[Long],
        this.idNetwork = obj.idNetwork // Option[Long],
        this.code = obj.code // Option[String],
        this.name = obj.name // Option[String]
    }
}